// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 1024px) and (max-width: 1439px) {
  .home_article_card_skeleton_container {
    height: 230px !important;
    width: 540px !important;
  }
  .home_article_card_skeleton_thumbnail {
    height: 227px !important;
    width: 280px !important;
  }

  .home_article_second_column_writer_name_and_views {
    font-size: 13px;
  }
  .home_article_card_details_skeleton_wrapper {
    height: 228px !important;
    width: 260px !important;
  }

  .home_article_card_skeleton_title {
    height: 50px !important;
    width: 250px !important;
  }

  .home_article_card_skeleton_subtitle {
    height: 100px !important;
    width: 250px !important;
  }

  .home_article_card_skeleton_author_details {
    height: 20px !important;
    width: 100px !important;
  }
  .home_article_card_author_details {
    width: 85px !important;
  }
  .home_article_card_skeleton_author_details_wrapper {
    height: 15px !important;
    width: 250px !important;
  }
  .home_article_card_skeleton_continue_read {
    height: 20px !important;
    width: 250px !important;
  }

  .home_article_card_skeleton_thumbnail {
    height: 227px !important;
    width: 225px !important;
  }
  .home_article_card_details_skeleton_wrapper {
    height: 228px !important;
    width: 325px !important;
  }
  .home_article_card_skeleton_title {
    height: 50px !important;
    width: 310px !important;
  }
  .home_article_card_skeleton_subtitle {
    height: 100px !important;
    width: 310px !important;
  }
  .home_article_card_skeleton_author_details {
    height: 20px !important;
    width: 120px !important;
  }

  .home_article_card_skeleton_continue_read {
    height: 20px !important;
    width: 310px !important;
  }

  .exposing_fake_news_second_column_image {
    width: 100%;
  }
  .fact_check_middle_card_container {
    width: 280px;
    height: 440px;
  }
  .fact_check_middle_card_image {
    height: 150px !important;
  }
  .fact_check_middle_card_title_wrapper {
    height: 75px !important;
    gap: 5px;
  }
  .fact_check_middle_card_title_skeleton {
    height: 20px !important;
  }
  .fact_check_middle_card_sub_title_skeleton {
    height: 15px !important;
  }

  .square_skeleton {
    width: 60px !important;
    height: 15px !important;
  }
  .fact_check_middle_card_sub_title_wrapper {
    height: 80px;
    gap: 5px;
  }
  .fact_check_middle_card_title_container {
    height: 58px !important;
  }
  .fact_check_middle_card_title {
    font-size: 11px;
    font-weight: 700;
  }
  .fact_check_middle_card_sub_title_container {
    height: 96px;
  }
  .fact_check_middle_card_sub_title {
    font-size: 10px;
  }
  .fact_check_middle_card_details_container {
    height: 40px;
  }
  .fact_check_middle_card_details {
    width: 41px;
    font-size: 12px;
  }
  .fact_check_middle_card_author_name {
    font-size: 12px;
  }
  .home_slot_card_container {
    height: 470px;
  }
  .home_slot_card_image_skeleton {
    height: 150px !important;
    width: 280px !important;
  }
  .home_slot_card_title_wrapper {
    height: 80px !important;
    width: 280px !important;
    padding: 8px;
  }

  .home_slot_card_title_skeleton {
    height: 75px !important;
    width: 280px !important;
  }

  .home_slot_card_content_wrapper {
    height: 140px !important;
    width: 280px !important;
    padding: 12px;
  }

  .home_slot_card_content_skeleton {
    height: 130px !important;
    width: 280px !important;
    font-size: 9px;
  }
  .home_slot_card_views_wrapper {
    height: 65px !important;
    width: 280px !important;
  }
  .home_slot_card_views_skeleton {
    height: 30px !important;
    width: 135px !important;
    padding-left: 5px;
  }
  .home_slot_card_read_more_skeleton {
    width: 280px !important;
  }

  .home_article_second_column {
    width: 52%;
  }

  .home_article_title {
    font-size: 20px;
  }
  .home_article_title_text {
    font-size: 30px;
    font-weight: bold;
  }

  .sub_title_text {
    font-size: 9px;
  }

  .home_article_row_container {
    margin-top: 20px;
  }

  .home_article_trending_container {
    height: 150px;
  }

  .home_trending_title_text {
    font-size: 10px !important;
  }
  .home_videos_section_mobile_view {
    display: none !important;
  }
  .user_contribute_stories_main_container {
    grid-template-columns: 24% 37% 32% !important;
  }
  .become_member_content {
    font-size: 15px !important;
    line-height: 1.8;
  }
  .become_member_content_ta {
    font-size: 18px !important;
    line-height: 1.5;
  }
  .home_user_contribution_two_image_box {
    width: 160px !important;
  }
  .contribute_user_name,
  .time-tag,
  .view-count-tag,
  .user_contribute_publish_time,
  .home_user_contribution_two_profile {
    font-size: 12px !important;
  }
  .continue_reading_text_ta {
    font-size: 9px !important;
  }
  .home_user_contribution_two_title {
    font-size: 10px !important;
    line-height: 17px;
  }
  .view-count-icon,
  .reading_time_icon {
    width: 10px;
  }
  .continue_reading_text {
    font-size: 9px !important;
  }
  .home_user_contribute_title {
    font-size: 15px !important;
  }
  .empower_truth_tag {
    font-size: 24px !important;
  }
  .home_user_contribution_mobile_view_main_container {
    display: none !important;
  }

  .home_slot_card_views_wrapper {
    height: 55px !important;
    width: 100% !important;
    padding: 10px;
  }

  .home_slot_card_staff_name_and_date {
    height: 30px !important;
    width: 135px !important;
  }

  .home_slot_card_read_more_skeleton {
    width: 280px !important;
    padding: 8px;
  }

  .signatory_logo {
    width: 110px;
    cursor: pointer !important;
    z-index: 1;
  }
  .home_slot_and_logo_wrapper {
    width: 92%;
  }
  .slots_card_wrapper {
    height: 480px;
    padding-right: 50px !important;
  }
  .logo_content {
    height: 50%;
    width: 80%;
  }

  .home_ifcn_logo_and_content {
    height: 450px;
  }
  .hide_content_in_desktop {
    display: none;
  }
  .exposing_fake_news_third_column_title {
    font-size: 10px;
  }
  .exposing_fake_news_second_column_details {
    font-size: 11px;
    width: 50px;
  }
  .home_article_row_wrapper {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .title_text {
    font-size: 12px;
  }
  .exposing_fake_news_second_column_title {
    font-size: 14px;
    font-weight: 700;
  }
  .exposing_fake_news_second_column_sub_title {
    font-size: 11px;
  }
  .exposing_fake_news_second_column_author_name {
    font-size: 9px;
  }
  .exposing_fake_news_first_column_button {
    width: 100%;
    height: 30px;
    font-size: 9px;
  }
  .exposing_fake_news_first_column_details {
    height: 130px;
  }
  .home_article_second_column_details {
    height: 130px;
  }
  .home_fact_check_mobile_view_wrapper {
    display: none !important;
  }
  .exposing_fake_news_button {
    height: 40px;
    font-size: 12px;
  }
  .exposing_fake_news_third_column_name {
    font-size: 9px;
  }
  .user_contributed_module_title_ta {
    font-size: 22px !important;
  }
  .user_contributed_module_title {
    font-size: 30px !important;
  }
  .user_contributed_story_container {
    height: 520px !important;
  }
  .home_user_contribution_two_text_main_container {
    padding: 10px !important;
  }
  .home_videos_subscribe_button {
    background-color: #ef1d26;
    color: #fff;
    border-radius: 10px;
    width: 50%;
    height: 40px;
    align-items: center;
    justify-content: space-around;
    display: flex;
    margin-bottom: 20px;
  }
  .home_awards_card_image_overlay_text {
    font-family: "Lato";
    font-size: 12px;
  }
  .donation_hash_text {
    font-size: 60px !important;
  }
  .donation_fight_against_text {
    font-size: 28px !important;
  }
  .home_donatio_content {
    font-size: 12px;
  }

  .slot_main_container {
    width: 20%;
    height: 450px !important;
  }
  .slot_container_height {
    height: 440px !important;
  }

  .slot_image_box {
    height: 230px !important;
  }
  .slot_card_title {
    font-size: 11px !important;
  }
  .slot_card_title_en {
    font-size: 14px !important;
  }
  .slot_card_sub_title_en {
    font-size: calc(33vw / 40) !important;
    height: 132px !important;
  }
  .slot_card_sub_title {
    font-size: 8px !important;
    height: 140px !important;
    line-height: 14px;
  }
  .slot_card_details {
    padding: 10px !important;
  }
  .home_slot_description {
    font-size: 10px !important;
  }
  .home_slot_youturn_present_title {
    font-size: 15px !important;
  }
  .home_slot_title {
    font-size: 32px !important;
  }

  .donate_amt_content_text {
    font-size: 12px;
  }
  .donate_inr_text {
    font-size: 12px;
  }
  .badge_default {
    height: 25px;
    width: 45px;
    font-size: 12px;
  }
  .badge_selected {
    height: 25px;
    width: 45px;
    font-size: 12px;
  }

  .home_donation_third_column_container {
    justify-content: flex-end;
  }

  .home_videos_second_column_overlay_play_button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .home_article_card_author_name_container {
    width: 150px !important;
  }
  */ .home_user_contribution_image {
    width: 40% !important;
    object-fit: cover;
  }
  .home_article_trending_container_skeleton {
    height: 180px !important;
  }
  .slot_card_footer_content {
    height: 20px;
  }
  .home_slot_card_author_name {
    font-size: 10px;
  }
  .home_slot_card_author_detail {
    height: 22px;
    width: 100%;
  }
  .slot_card_title_container {
    font-size: 14px;
    line-height: 17px;
  }
  .slot_card_subtitle_container {
    height: 85px;
    font-size: 10px;
    line-height: 18px;
  }
  .slot_card_subtitle_container_ta {
    height: 147px;
    font-size: 9px;
    line-height: 18px;
  }

  .time_tag_text {
    font-size: 9px;
  }
  .user_contributed_story_container_footer {
    height: 15px;
  }
  .home_user_contribute_second_column_container {
    gap: 0px !important;
  }
  .home_user_contribution_card_container {
    height: 90px !important;
  }
  .home_trending_author_text {
    font-size: 9px;
  }
  .header_drawer_theme {
    display: none !important;
  }
  .fact_trending_image {
    height: 180px;
  }
  .home_trending_title_text_en {
    font-size: 10px !important;
  }
  .exposing_fake_news_first_column_skeleton {
    width: 410px !important;
    height: 425px !important;
  }
  .exposing_fake_news_first_column_title_ta {
    font-size: 12px !important;
  }
  .exposing_fake_news_first_column_writer_name_and_views {
    font-size: 11px;
  }
  .exposing_fake_news_third_column_skeleton {
    height: 180px !important;
    width: 250px !important;
  }
  .home_videos_title_text_ta {
    font-size: 30px;
    font-family: "Kufam";
    font-weight: 600;
  }

  .home_page_videos_text_content_ta {
    font-size: 15px !important;
  }

  .donation_input {
    width: 75% !important;
  }
  .home_donation_input {
    width: 100%;
    height: 100%;
  }
  .home_article_button_in_mobile {
    display: none;
  }
  .home_amount_container_ta {
    display: flex;
    flex-direction: row;
    gap: 25px;
    align-items: center;
  }
  .app-download-icon{
    width: 4%;
    height: 8%;
    position: fixed;
    left: 10px;
    bottom: 75px;
    background-color: #0065cc;
    border-radius: 50%;
    z-index: 99;
    cursor: pointer;
    border: 1px solid #0065cc;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/screen_1024_1439/screen_1024_1439_home.css"],"names":[],"mappings":"AAAA;EACE;IACE,wBAAwB;IACxB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,QAAQ;EACV;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,YAAY;IACZ,QAAQ;EACV;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;IACxB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,uBAAuB;IACvB,cAAc;EAChB;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;;;;;IAKE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;EACA;;IAEE,WAAW;EACb;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,0BAA0B;IAC1B,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;IACb,8BAA8B;EAChC;EACA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,qCAAqC;IACrC,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,wBAAwB;IACxB,iBAAiB;EACnB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;EACA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,cAAc;EAChB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;EACA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;EACvB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;EACA;IACE,SAAS;IACT,UAAU;IACV,eAAe;IACf,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,yBAAyB;EAC3B;AACF","sourcesContent":["@media only screen and (min-width: 1024px) and (max-width: 1439px) {\n  .home_article_card_skeleton_container {\n    height: 230px !important;\n    width: 540px !important;\n  }\n  .home_article_card_skeleton_thumbnail {\n    height: 227px !important;\n    width: 280px !important;\n  }\n\n  .home_article_second_column_writer_name_and_views {\n    font-size: 13px;\n  }\n  .home_article_card_details_skeleton_wrapper {\n    height: 228px !important;\n    width: 260px !important;\n  }\n\n  .home_article_card_skeleton_title {\n    height: 50px !important;\n    width: 250px !important;\n  }\n\n  .home_article_card_skeleton_subtitle {\n    height: 100px !important;\n    width: 250px !important;\n  }\n\n  .home_article_card_skeleton_author_details {\n    height: 20px !important;\n    width: 100px !important;\n  }\n  .home_article_card_author_details {\n    width: 85px !important;\n  }\n  .home_article_card_skeleton_author_details_wrapper {\n    height: 15px !important;\n    width: 250px !important;\n  }\n  .home_article_card_skeleton_continue_read {\n    height: 20px !important;\n    width: 250px !important;\n  }\n\n  .home_article_card_skeleton_thumbnail {\n    height: 227px !important;\n    width: 225px !important;\n  }\n  .home_article_card_details_skeleton_wrapper {\n    height: 228px !important;\n    width: 325px !important;\n  }\n  .home_article_card_skeleton_title {\n    height: 50px !important;\n    width: 310px !important;\n  }\n  .home_article_card_skeleton_subtitle {\n    height: 100px !important;\n    width: 310px !important;\n  }\n  .home_article_card_skeleton_author_details {\n    height: 20px !important;\n    width: 120px !important;\n  }\n\n  .home_article_card_skeleton_continue_read {\n    height: 20px !important;\n    width: 310px !important;\n  }\n\n  .exposing_fake_news_second_column_image {\n    width: 100%;\n  }\n  .fact_check_middle_card_container {\n    width: 280px;\n    height: 440px;\n  }\n  .fact_check_middle_card_image {\n    height: 150px !important;\n  }\n  .fact_check_middle_card_title_wrapper {\n    height: 75px !important;\n    gap: 5px;\n  }\n  .fact_check_middle_card_title_skeleton {\n    height: 20px !important;\n  }\n  .fact_check_middle_card_sub_title_skeleton {\n    height: 15px !important;\n  }\n\n  .square_skeleton {\n    width: 60px !important;\n    height: 15px !important;\n  }\n  .fact_check_middle_card_sub_title_wrapper {\n    height: 80px;\n    gap: 5px;\n  }\n  .fact_check_middle_card_title_container {\n    height: 58px !important;\n  }\n  .fact_check_middle_card_title {\n    font-size: 11px;\n    font-weight: 700;\n  }\n  .fact_check_middle_card_sub_title_container {\n    height: 96px;\n  }\n  .fact_check_middle_card_sub_title {\n    font-size: 10px;\n  }\n  .fact_check_middle_card_details_container {\n    height: 40px;\n  }\n  .fact_check_middle_card_details {\n    width: 41px;\n    font-size: 12px;\n  }\n  .fact_check_middle_card_author_name {\n    font-size: 12px;\n  }\n  .home_slot_card_container {\n    height: 470px;\n  }\n  .home_slot_card_image_skeleton {\n    height: 150px !important;\n    width: 280px !important;\n  }\n  .home_slot_card_title_wrapper {\n    height: 80px !important;\n    width: 280px !important;\n    padding: 8px;\n  }\n\n  .home_slot_card_title_skeleton {\n    height: 75px !important;\n    width: 280px !important;\n  }\n\n  .home_slot_card_content_wrapper {\n    height: 140px !important;\n    width: 280px !important;\n    padding: 12px;\n  }\n\n  .home_slot_card_content_skeleton {\n    height: 130px !important;\n    width: 280px !important;\n    font-size: 9px;\n  }\n  .home_slot_card_views_wrapper {\n    height: 65px !important;\n    width: 280px !important;\n  }\n  .home_slot_card_views_skeleton {\n    height: 30px !important;\n    width: 135px !important;\n    padding-left: 5px;\n  }\n  .home_slot_card_read_more_skeleton {\n    width: 280px !important;\n  }\n\n  .home_article_second_column {\n    width: 52%;\n  }\n\n  .home_article_title {\n    font-size: 20px;\n  }\n  .home_article_title_text {\n    font-size: 30px;\n    font-weight: bold;\n  }\n\n  .sub_title_text {\n    font-size: 9px;\n  }\n\n  .home_article_row_container {\n    margin-top: 20px;\n  }\n\n  .home_article_trending_container {\n    height: 150px;\n  }\n\n  .home_trending_title_text {\n    font-size: 10px !important;\n  }\n  .home_videos_section_mobile_view {\n    display: none !important;\n  }\n  .user_contribute_stories_main_container {\n    grid-template-columns: 24% 37% 32% !important;\n  }\n  .become_member_content {\n    font-size: 15px !important;\n    line-height: 1.8;\n  }\n  .become_member_content_ta {\n    font-size: 18px !important;\n    line-height: 1.5;\n  }\n  .home_user_contribution_two_image_box {\n    width: 160px !important;\n  }\n  .contribute_user_name,\n  .time-tag,\n  .view-count-tag,\n  .user_contribute_publish_time,\n  .home_user_contribution_two_profile {\n    font-size: 12px !important;\n  }\n  .continue_reading_text_ta {\n    font-size: 9px !important;\n  }\n  .home_user_contribution_two_title {\n    font-size: 10px !important;\n    line-height: 17px;\n  }\n  .view-count-icon,\n  .reading_time_icon {\n    width: 10px;\n  }\n  .continue_reading_text {\n    font-size: 9px !important;\n  }\n  .home_user_contribute_title {\n    font-size: 15px !important;\n  }\n  .empower_truth_tag {\n    font-size: 24px !important;\n  }\n  .home_user_contribution_mobile_view_main_container {\n    display: none !important;\n  }\n\n  .home_slot_card_views_wrapper {\n    height: 55px !important;\n    width: 100% !important;\n    padding: 10px;\n  }\n\n  .home_slot_card_staff_name_and_date {\n    height: 30px !important;\n    width: 135px !important;\n  }\n\n  .home_slot_card_read_more_skeleton {\n    width: 280px !important;\n    padding: 8px;\n  }\n\n  .signatory_logo {\n    width: 110px;\n    cursor: pointer !important;\n    z-index: 1;\n  }\n  .home_slot_and_logo_wrapper {\n    width: 92%;\n  }\n  .slots_card_wrapper {\n    height: 480px;\n    padding-right: 50px !important;\n  }\n  .logo_content {\n    height: 50%;\n    width: 80%;\n  }\n\n  .home_ifcn_logo_and_content {\n    height: 450px;\n  }\n  .hide_content_in_desktop {\n    display: none;\n  }\n  .exposing_fake_news_third_column_title {\n    font-size: 10px;\n  }\n  .exposing_fake_news_second_column_details {\n    font-size: 11px;\n    width: 50px;\n  }\n  .home_article_row_wrapper {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n  .title_text {\n    font-size: 12px;\n  }\n  .exposing_fake_news_second_column_title {\n    font-size: 14px;\n    font-weight: 700;\n  }\n  .exposing_fake_news_second_column_sub_title {\n    font-size: 11px;\n  }\n  .exposing_fake_news_second_column_author_name {\n    font-size: 9px;\n  }\n  .exposing_fake_news_first_column_button {\n    width: 100%;\n    height: 30px;\n    font-size: 9px;\n  }\n  .exposing_fake_news_first_column_details {\n    height: 130px;\n  }\n  .home_article_second_column_details {\n    height: 130px;\n  }\n  .home_fact_check_mobile_view_wrapper {\n    display: none !important;\n  }\n  .exposing_fake_news_button {\n    height: 40px;\n    font-size: 12px;\n  }\n  .exposing_fake_news_third_column_name {\n    font-size: 9px;\n  }\n  .user_contributed_module_title_ta {\n    font-size: 22px !important;\n  }\n  .user_contributed_module_title {\n    font-size: 30px !important;\n  }\n  .user_contributed_story_container {\n    height: 520px !important;\n  }\n  .home_user_contribution_two_text_main_container {\n    padding: 10px !important;\n  }\n  .home_videos_subscribe_button {\n    background-color: #ef1d26;\n    color: #fff;\n    border-radius: 10px;\n    width: 50%;\n    height: 40px;\n    align-items: center;\n    justify-content: space-around;\n    display: flex;\n    margin-bottom: 20px;\n  }\n  .home_awards_card_image_overlay_text {\n    font-family: \"Lato\";\n    font-size: 12px;\n  }\n  .donation_hash_text {\n    font-size: 60px !important;\n  }\n  .donation_fight_against_text {\n    font-size: 28px !important;\n  }\n  .home_donatio_content {\n    font-size: 12px;\n  }\n\n  .slot_main_container {\n    width: 20%;\n    height: 450px !important;\n  }\n  .slot_container_height {\n    height: 440px !important;\n  }\n\n  .slot_image_box {\n    height: 230px !important;\n  }\n  .slot_card_title {\n    font-size: 11px !important;\n  }\n  .slot_card_title_en {\n    font-size: 14px !important;\n  }\n  .slot_card_sub_title_en {\n    font-size: calc(33vw / 40) !important;\n    height: 132px !important;\n  }\n  .slot_card_sub_title {\n    font-size: 8px !important;\n    height: 140px !important;\n    line-height: 14px;\n  }\n  .slot_card_details {\n    padding: 10px !important;\n  }\n  .home_slot_description {\n    font-size: 10px !important;\n  }\n  .home_slot_youturn_present_title {\n    font-size: 15px !important;\n  }\n  .home_slot_title {\n    font-size: 32px !important;\n  }\n\n  .donate_amt_content_text {\n    font-size: 12px;\n  }\n  .donate_inr_text {\n    font-size: 12px;\n  }\n  .badge_default {\n    height: 25px;\n    width: 45px;\n    font-size: 12px;\n  }\n  .badge_selected {\n    height: 25px;\n    width: 45px;\n    font-size: 12px;\n  }\n\n  .home_donation_third_column_container {\n    justify-content: flex-end;\n  }\n\n  .home_videos_second_column_overlay_play_button {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .home_article_card_author_name_container {\n    width: 150px !important;\n  }\n  */ .home_user_contribution_image {\n    width: 40% !important;\n    object-fit: cover;\n  }\n  .home_article_trending_container_skeleton {\n    height: 180px !important;\n  }\n  .slot_card_footer_content {\n    height: 20px;\n  }\n  .home_slot_card_author_name {\n    font-size: 10px;\n  }\n  .home_slot_card_author_detail {\n    height: 22px;\n    width: 100%;\n  }\n  .slot_card_title_container {\n    font-size: 14px;\n    line-height: 17px;\n  }\n  .slot_card_subtitle_container {\n    height: 85px;\n    font-size: 10px;\n    line-height: 18px;\n  }\n  .slot_card_subtitle_container_ta {\n    height: 147px;\n    font-size: 9px;\n    line-height: 18px;\n  }\n\n  .time_tag_text {\n    font-size: 9px;\n  }\n  .user_contributed_story_container_footer {\n    height: 15px;\n  }\n  .home_user_contribute_second_column_container {\n    gap: 0px !important;\n  }\n  .home_user_contribution_card_container {\n    height: 90px !important;\n  }\n  .home_trending_author_text {\n    font-size: 9px;\n  }\n  .header_drawer_theme {\n    display: none !important;\n  }\n  .fact_trending_image {\n    height: 180px;\n  }\n  .home_trending_title_text_en {\n    font-size: 10px !important;\n  }\n  .exposing_fake_news_first_column_skeleton {\n    width: 410px !important;\n    height: 425px !important;\n  }\n  .exposing_fake_news_first_column_title_ta {\n    font-size: 12px !important;\n  }\n  .exposing_fake_news_first_column_writer_name_and_views {\n    font-size: 11px;\n  }\n  .exposing_fake_news_third_column_skeleton {\n    height: 180px !important;\n    width: 250px !important;\n  }\n  .home_videos_title_text_ta {\n    font-size: 30px;\n    font-family: \"Kufam\";\n    font-weight: 600;\n  }\n\n  .home_page_videos_text_content_ta {\n    font-size: 15px !important;\n  }\n\n  .donation_input {\n    width: 75% !important;\n  }\n  .home_donation_input {\n    width: 100%;\n    height: 100%;\n  }\n  .home_article_button_in_mobile {\n    display: none;\n  }\n  .home_amount_container_ta {\n    display: flex;\n    flex-direction: row;\n    gap: 25px;\n    align-items: center;\n  }\n  .app-download-icon{\n    width: 4%;\n    height: 8%;\n    position: fixed;\n    left: 10px;\n    bottom: 75px;\n    background-color: #0065cc;\n    border-radius: 50%;\n    z-index: 99;\n    cursor: pointer;\n    border: 1px solid #0065cc;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
